<template>
	<div class="admin-main">
		<div class="admin-top flex-rcc">
			结算信息
		</div>
		<van-form validate-first @submit="onSubmit" class="form-box">
			<div class="field-box">
				<van-field name="radio" label="主体类型：">
					<template #input>
						<van-radio-group v-model="radio" direction="horizontal">
							<van-radio name="1">个体工商户</van-radio>
							<van-radio name="2">公司</van-radio>
						</van-radio-group>
					</template>
				</van-field>
				<div class="remind">1、若主体为企业/党政、机关及事业单位/其他组织，可填写：对公银行账户。
					2、若主体为个体户，可选择填写：对公银行账户或经营者个人银行卡。</div>
			</div>
			<div class="field-box">
				<van-field v-model="registration" registration="card" label="开户名称：" placeholder="请输入开户名称" :rules="[{ required: true, message: '请输入开户名称' }]"></van-field>
				<div class="remind">1、选择“经营者个人银行卡”时，开户名称必须与“经营者证件姓名”一致。<br>
					2、选择“对公银行账户”时，开户名称必须与营业执照上的“商户名称”一致。</div>
			</div>
			<div class="field-box">
				<van-field
						readonly
						clickable
						name="picker"
						:value="value"
						label="开户银行"
						placeholder="点击选择银行"
						@click="showPicker = true"></van-field>
			</div>
			<div class="field-box">
				<van-field v-model="registration" registration="card" label="开户银行省市编码：" placeholder="请输入开户行所在城市邮政编码" :rules="[{ required: true, message: '请输入开户行所在城市邮政编码' }]"></van-field>
			</div>
			<div class="field-box">
				<van-field v-model="registration" registration="card" label="开户银行全称（含支行) ：" placeholder="请输入开户支行" :rules="[{ required: true, message: '请输入开户支行' }]"></van-field>
			</div>
			<div class="field-box">
				<van-field v-model="registration" registration="card" label="银行账号：" placeholder="请输入银行卡号" :rules="[{ required: true, message: '请输入银行卡号' }]"></van-field>
			</div>
			<div class="field-box">
				<van-field v-model="services" name="services" label="个体户/企业支付宝账号：" placeholder="请输入支付宝收款的账号" :rules="[{ required: true, message: '请输入支付宝收款的账号' }]"></van-field>
				<div class="remind">1、只能是个体工商户申请的支付宝账号或者企业营业执照<br>
					2、申请的支付宝账号，没有则不填写，我们将为您申请一个</div>
			</div>
			<div class="bottom-bar-placeholder"></div>
			<div class="admin-bottom-bar">
				<van-button native-type="submit" class="button-default" :class="isApp === 'isWeixin' ? 'wx-button-primary' : 'zfb-button-primary'" >
					下一步
				</van-button>
			</div>
		</van-form>
		
		<van-popup v-model="showPicker" position="bottom">
			<van-picker
					show-toolbar
					:columns="columns"
					@confirm="onConfirm"
					@cancel="showPicker = false"></van-picker>
		</van-popup>
	</div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: "index",
		data () {
      return{
        radiod: 0,
        uploader: [{ url: 'https://img.yzcdn.cn/vant/leaf.jpg' }],
        services: '',
        registration: '',
        name: '',
        columns: ['杭州', '宁波', '温州', '嘉兴', '湖州'],
        showPicker: false,
			}
		},
    computed: {
      ...mapState(['isApp', 'openId'])
    },
    created () {
    },
    methods: {
      onConfirm(value) {
        this.value = value;
        this.showPicker = false;
      },
			next () {},
      onSubmit(values) {
        console.log('submit', values)
      }
    }
  };
</script>

<style scoped lang="stylus">
	.van-cell
		padding 5px 2px !important
		&:after
			border none !important
			border-bottom 0 !important
</style>
